import React, {useContext} from "react";
import background from "../../../images/bg_yellow_flower_field.jpg";
import {createTheme,ThemeProvider} from "@mui/material/styles";
import {MainContext} from "../../../context";


export default function AfterLoginDesktop(){
    const theme = createTheme();
    const { toggleClose } = useContext(MainContext)

    return(<>
            <div style={{backgroundImage:`url(${background})`,padding:250}} onClick={toggleClose}>
                <ThemeProvider theme={theme}>
                <div style={{ marginTop:-80,alignItems:"center",display:'flex',flexDirection:"column"}}>
                <img alt="No Images" src="images/img_splash_title.png"
                     style={{
                         display:'flex',
                         alignItems: "center",
                         width:"auto",
                         height:'450px'
                     }}/>
                </div>
                </ThemeProvider>
            </div>
        </>
    )
}